var oldScrollY = window.scrollY;
function scrollingClass(event) {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if(y === 0) {
        document.body.classList.remove('scrolling');
        document.body.classList.remove('scrolling-up');
        document.body.classList.remove('scrolling-down');
    } else {
        document.body.classList.add('scrolling');
    }
    if(oldScrollY < y){
        document.body.classList.add('scrolling-down');
        document.body.classList.remove('scrolling-up');
    } else {
        document.body.classList.add('scrolling-up');
        document.body.classList.remove('scrolling-down');
    }
    oldScrollY = y;
}

window.addEventListener('scroll', scrollingClass);
scrollingClass();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if(summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) {
        return;
    }
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if(!container) {
      return
  }
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function wrapIframe(options) {
    options.iframes.forEach(function(iframe) {
        var wrapper = document.createElement('div');
        wrapper.classList.add(options.iframeWrapperClass);

        iframe.parentNode.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);

        iframe.src = iframe.src;
    });
}

document.addEventListener("swiper-loaded", function(event) {
    renderSwatches()
})

document.addEventListener("recommendations-loaded", function(event) {
    renderSwatches()
})

function renderSwatches() {
    let swatches = document.querySelectorAll('.swatches > .swiper')
    if(swatches.length > 0) {
        swatches.forEach((swatch) => {
            const swiper = new Swiper(swatch, {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                nested: true,
//                 enabled: false,
//                 noSwiping: true,
//                 loopAdditionalSlides:0,
                rewind: true,
                slidesPerView: 4,
                spaceBetween : 7,
                initialSlide: 0,
                navigation: {
                    nextEl: swatch.parentElement.querySelector('.button-next'),
                }
            });
        })
    }
    let allSwatches = document.querySelectorAll('.swatches')
    if(allSwatches.length > 0) {
        allSwatches.forEach((swatch) => {
            let swatchItems = swatch.querySelectorAll('.swatch')
            if(swatchItems.length > 0) {
                swatchItems.forEach((swatchItem) => {
                    swatchItem.addEventListener('click', function(){
                        let variantId = swatchItem.dataset.variantId;
                        var cardProduct = swatchItem.closest('.card.product')
                        let image = this.dataset.image;
                        let alternateImage = this.dataset.imageAlternate;
                        let url = this.dataset.url;
                        let limited = this.dataset.limited;
                        if(limited) {
                            cardProduct.classList.add('limited')
                        } else {
                            cardProduct.classList.remove('limited')
                        }
                        let label = this.dataset.label;
                        let labelProduct = cardProduct.dataset.label;
                        let labelEl = cardProduct.querySelector('.product-label')
                        if(label) {
                            labelEl.innerHTML = label;
                            labelEl.classList.remove('hidden');
                        } else if(labelProduct) {
                            labelEl.innerHTML = labelProduct;
                            labelEl.classList.remove('hidden');
                        } else {
                            labelEl.innerHTML = '';
                            labelEl.classList.add('hidden');
                        }
                        var img = cardProduct.querySelector('.image .primary');
                        var imgAlt = cardProduct.querySelector('.image .alternate');
                        var links = cardProduct.querySelectorAll('a');
                        img.setAttribute('src', image)
                        imgAlt.setAttribute('src', alternateImage)
                        img.removeAttribute('srcset');
                        imgAlt.removeAttribute('srcset');
                        swatchItem.parentElement.querySelectorAll('.swatch').forEach((sibling) => {
                            sibling.classList.remove('active');
                        })
                        swatchItem.classList.add('active');
                        links.forEach((link) => {
                            link.setAttribute('href', url);
                        })
//                         cardProduct.querySelectorAll('.actions > .price').forEach((price) => {
//                             if(price.dataset.variantId == variantId) {
//                                 price.classList.remove('hidden');
//                             } else {
//                                 price.classList.add('hidden');
//                             }
//                         })
                    });
                })
            }
        })
    }
}

class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.timer = null;
        this.items = this.querySelectorAll('.header-menu.mega');
        this.menus = this.querySelectorAll('.header-menu-content > .wrapper');
        this.links = this.querySelectorAll('.header-menu-content .menu-links a');
        this.items.forEach((item) => {
            item.addEventListener('mouseenter', this.menuOpen.bind(this));
            item.addEventListener('mouseleave', this.menuClose.bind(this));
        });
        this.menus.forEach((menu) => {
            menu.addEventListener('mouseenter', this.menuEnter.bind(this));
            menu.addEventListener('mouseleave', this.menuClose.bind(this));
        });
        if(this.links.length > 0) {
            let self = this
            this.links.forEach((link)=>{
                link.addEventListener('click',()=>{
                    self.menuClose()
                })
            })
        }
    }

    menuClose(event) {
        let $self = this;
        this.timer = setTimeout(function(){
            document.querySelector('body').classList.remove('desktop-menu-open');
            $self.items.forEach((item) => {
                item.classList.remove('active');
            })
        }, 400);
    }

    menuEnter(event) {
        clearTimeout(this.timer);
    }

    menuOpen(event) {
        var clickedItem = event.target;
        clearTimeout(this.timer);
        clickedItem.classList.add('active');
        document.querySelector('body').classList.add('desktop-menu-open');
        this.items.forEach((item) => {
            if(item != clickedItem) {
                item.classList.remove('active');
            }
        })
    }
}

customElements.define('mega-menu', MegaMenu);

class HeaderDrawer extends HTMLElement {
    constructor() {
        super();
        this.summary = this.querySelector('summary');
        this.parents = this.querySelectorAll('.parent > a');
        this.summary.addEventListener('click', this.summaryClick.bind(this))
        this.parents.forEach((item) => {
            item.addEventListener('click', this.itemClick.bind(this));
        });
    }
    
    itemClick(event) {
        event.preventDefault();
        event.target.closest('.parent').classList.toggle('active')
    }

    summaryClick(event) {
        if(this.summary.parentNode.hasAttribute('open')) {
            document.body.classList.remove('mobile-menu-open');
        } else {
            document.body.classList.add('mobile-menu-open');
        }
    }
}

customElements.define('header-drawer', HeaderDrawer);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class PopupTrigger extends HTMLElement {
  constructor() {
    super();
    this.popup = document.getElementById(this.dataset.trigger);
    if(this.popup) {
        this.addEventListener('click', this.onClick.bind(this))
        this.popup.addEventListener('click', this.onPopupClick.bind(this))
        this.close = this.popup.querySelectorAll('[data-close]')
        if(this.close) {
            this.close.forEach((close)=>{
                close.addEventListener('click', this.onClose.bind(this))
            })
        }
    }
  }

  onClose(event) {
    event.preventDefault();
    document.querySelector('body').classList.remove('fav-popup-open')
    this.popup.classList.remove('active')
  }

  onClick(event) {
    event.preventDefault();
    document.querySelector('body').classList.add('fav-popup-open')
    this.popup.querySelector('.loading-overlay').classList.remove('hidden')
    this.popup.classList.add('active')
    var self = this;
    var http = new XMLHttpRequest();
    let sectionSelector = this.dataset.sectionSelector;
    
    http.onreadystatechange = function () {
        if (this.readyState == 4) {
            try {
                
                // Convert the HTML string into a document object
                
                var parser = new DOMParser();
                var doc = parser.parseFromString(this.response, 'text/html');
                var elm = self.popup.querySelector('.content');
                self.popup.querySelector('.loading-overlay').classList.add('hidden')
                elm.innerHTML = doc.querySelector(sectionSelector).outerHTML;
                Array.from(elm.querySelectorAll("script:not([src])")).forEach( oldScript => {
                    const newScript = document.createElement("script");
                    Array.from(oldScript.attributes).forEach( attr => newScript.setAttribute(attr.name, attr.value) );
                    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                    oldScript.parentNode.replaceChild(newScript, oldScript);
                });
//                             let event = new Event("swiper-loaded", {bubbles: true});
//                             document.body.dispatchEvent(event);
            } catch(err) {
                console.log(err.message + " in " + this.response);
                return;
            }
        }
    };
    
    let url = this.dataset.url;

    if( typeof url == 'undefined') {
        var elm = self.popup.querySelector('.content');
        self.popup.querySelector('.loading-overlay').classList.add('hidden')
        elm.innerHTML = document.querySelector(sectionSelector).outerHTML;
        elm.querySelector('.fav-tabs').classList.remove('hidden');
        Array.from(elm.querySelectorAll("script:not([src])")).forEach( oldScript => {
            const newScript = document.createElement("script");
            Array.from(oldScript.attributes).forEach( attr => newScript.setAttribute(attr.name, attr.value) );
            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
            oldScript.parentNode.replaceChild(newScript, oldScript);
        });
    } else {
        http.open('GET', url, true);
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        http.send();
    }

  }

  onPopupClick(event) {
      if(event.target.getAttribute('id') == this.dataset.trigger) {
        this.onClose(event);
    }
  }
}

customElements.define('popup-trigger', PopupTrigger);

class MediaZoom extends HTMLElement {
  constructor() {
    super();
    this.popup = document.getElementById('media-zoom');
    if(this.popup) {
//         this.addEventListener('click', this.onClick.bind(this))
        this.popup.addEventListener('click', this.onPopupClick.bind(this))
        this.close = this.popup.querySelectorAll('[data-close]')
        if(this.close) {
            this.close.forEach((close)=>{
                close.addEventListener('click', this.onClose.bind(this))
            })
        }
    }
    this.images = document.querySelectorAll('.product-media .image-container')
    if(this.images.length > 0) {
        this.images.forEach((container) => {
            container.addEventListener('click', this.onImageClick.bind(this))
        })
    }
  }

    onImageClick(event) {
        let image = event.target
        let index = Array.prototype.indexOf.call(image.closest('.swiper-wrapper').querySelectorAll('.image-container:not(.hidden)'), image.parentElement)
        let color = image.parentNode.dataset.color
        let sameColors = document.querySelectorAll(`.product-media .image-container[data-color="${color}"]`)
        let slider = this.popup.querySelector('.swiper-wrapper')
        slider.innerHTML = ''
        if(sameColors.length > 0) {
            sameColors.forEach((container) => {
                let img = container.querySelector('img[srcset]')
                if(img) {
                    let item = document.createElement('div');
                    item.classList.add('swiper-slide');
                    let itemContainer = document.createElement('div');
                    itemContainer.classList.add('image-container');
                    itemContainer.classList.add('swiper-zoom-container');
                    let sliderImg = document.createElement('img');
                    sliderImg.setAttribute('src', img.dataset.full)

                    itemContainer.appendChild(sliderImg);
                    item.appendChild(itemContainer);
                    slider.appendChild(item);
                } else {
                    const video = container.querySelector('video')
                    const clone = video.cloneNode(true);
                    console.log(video);

                    let item = document.createElement('div');
                    item.classList.add('swiper-slide');
                    let itemContainer = document.createElement('div');
                    itemContainer.classList.add('image-container');

                    itemContainer.appendChild(clone);
                    item.appendChild(itemContainer);
                    slider.appendChild(item);
                }
            })
            this.showPopup(index)
        }
    }

  onClose(event) {
    event.preventDefault();
    document.querySelector('body').classList.remove('fav-popup-open')
    this.popup.classList.remove('active')
  }

  showPopup(index=0) {
    document.querySelector('body').classList.add('fav-popup-open')
//     this.popup.querySelector('.loading-overlay').classList.remove('hidden')
    this.popup.classList.add('active')
    this.swiper = new Swiper('#media-zoom .swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        zoom: true,
        initialSlide: index,
//         loopAdditionalSlides:4,
        slidesPerView: 1,
        spaceBetween : 0,
        mousewheel: {
            forceToAxis: true,
        },
        navigation: {
            nextEl: '.swiper-button-next-zoom',
            prevEl: '.swiper-button-prev-zoom',
        },
        pagination: {
            el: '.swiper-zoom-pagination',
            type: 'progressbar',
        },
//         breakpoints: {
//             768: {
//                 direction: 'horizontal',
//             },
//         },
        on: {
            init: function (swiper) {
                // do something
                let slide = swiper.slides[swiper.activeIndex]
                let shift = slide.scrollWidth / 3;
                slide.scrollTo(shift, 0)
            },
            slideChange: function (swiper) {
                // do something
                let slide = swiper.slides[swiper.activeIndex]
                let shift = slide.scrollWidth / 3;
                slide.scrollTo(shift, 0)
            },
        }
    });
//     this.popup.querySelector('.loading-overlay').classList.add('hidden')
    var self = this;
  }

  onPopupClick(event) {
//       if(event.target.getAttribute('id') == this.dataset.trigger) {
//         this.onClose(event);
//     }
  }
}

customElements.define('media-zoom', MediaZoom);

window.addEventListener('DOMContentLoaded', (event) => {

    // Theme-specific selectors to make iframes responsive
    var iframeSelectors =
        '.article-template__content iframe[src*="youtube.com/embed"],' +
        '.article-template__content iframe[src*="player.vimeo"],' +
        '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
        '.custom__item-inner--html iframe[src*="player.vimeo"]';

    wrapIframe({
        iframes: document.querySelectorAll(iframeSelectors),
        iframeWrapperClass: 'video-wrapper'
    })
});

(function (ns, fetch) {
    ns.fetch = function() {
        const response = fetch.apply(this, arguments);
        response.then(res => {
            if (`${window.location.origin}/cart/add.js`.includes(res.url)) {
                let r = res.clone()
                r.json().then(data => {
                    customElevarAddToCart(data)
                })
            }
        });
        return response
    }
}(window, window.fetch));

function customElevarAddToCart(res) {
    let event_name = 'dl_add_to_cart'
    let complete_the_look = false
    let atc_position = 'Primary'
    if(typeof res.properties['_complete_the_look'] != 'undefined') {
        event_name = 'dl_add_to_cart'
        complete_the_look = true
        atc_position = 'Secondary'
    }
    if(typeof res.properties['_upsell'] != 'undefined') {
        event_name = 'dl_add_to_cart'
        atc_position = 'Tertiary'
    }
    if(typeof res.properties['_gwp'] != 'undefined') {
        event_name = 'dl_add_to_cart'
        atc_position = 'Quaternary'
    }
    if(res.final_price == 0 ||
        res.url == '/collections/all'
    ) {
        return;
    }
    let price = res.final_price/100,
        compare_at_price = res.final_price < res.price ? res.price/100 : 0
  console.log('RES')
  console.log(res)
    const products = [
        {
            id: res.sku, // SKU
            name: res.product_title, // Product title
            brand: res.vendor,
            category: res.product_type,
            variant: res.variant_title,
            price: price.toString(), // TODO convert
            quantity: res.quantity.toString(), // Not required for dl_select_item & dl_view_item
//                 position: item.position, // Only required for dl_select_item; position in the list of search results, collection views and position in cart indexed starting at 1
            list: 'https://wolfandshepherd.com' + res.url, // The list the product was discovered from
            product_id: res.product_id.toString(), // The product_id
            variant_id: res.variant_id.toString(), // id or variant_id
            compare_at_price: compare_at_price.toString(), // If available on dl_view_item & dl_add_to_cart otherwise use "0.0"
            image: res.image, // If available, otherwise use an empty string
            fav: 'silution',
            url: 'https://wolfandshepherd.com' + res.url
//             inventory: "5" // If available, only required on dl_view_item
        },
    ]
    // console.log(atc_position);
    window.ElevarDataLayer.push({
        event: event_name,
//         user_properties: userProperties,
        ecommerce: {
            currencyCode: "USD",
            add: {
                actionField: {
                    action : 'add',
                    list: 'https://wolfandshepherd.com' + res.url // this should be the collection page URL that user clicked product from
                },
                complete_the_look: complete_the_look,
                atc_position: atc_position,
                products: products // See the products array below
            }
        }
    });
}